import {Component, OnInit} from '@angular/core';
import {FileQueueService} from '../../services/file-queue.service';
import {animate, query, stagger, state, style, transition, trigger} from '@angular/animations';
import {QueueModel} from '../../models/queue.model';
import {TranslateService} from '@ngx-translate/core';


export const listAnimation = trigger('listAnimation', [
    transition('* <=> *', [
        query(':enter',
            [
                style({opacity: 0, height: '0px'})
                , stagger('30ms', animate('300ms ease-out', style({opacity: 1, height: '69px'})))],
            {optional: true}
        ),
        query(':leave',
            animate('200ms', style({opacity: 0, height: '0px'})),
            {optional: true}
        )
    ])
]);
export const fade = trigger('fade', [
    state('in', style({opacity: 1})),
    transition(':enter', [style({opacity: 0}), animate('300ms ease-out')]),
    transition(':leave', animate('150ms ease-out', style({opacity: 0})))
]);

@Component({
    selector: 'app-component-file-queue',
    templateUrl: './file-queue.component.html',
    styleUrls: ['./file-queue.component.scss'],
    animations: [listAnimation, fade]
})

export class FileQueueComponent implements OnInit {
    public minimize = true;

    public tasks: QueueModel[] = [];

    private loadStatuses = {
        queued: '',
        upload: '',
        loaded: '',
        error: ''
    };

    constructor(
        public fileQueueService: FileQueueService,
        protected translateService: TranslateService,
    ) {
        this.translateService.get(['STATUS_LOAD']).subscribe(data => {
            this.loadStatuses = {
                queued: data.STATUS_LOAD.queued,
                upload: data.STATUS_LOAD.upload,
                loaded: data.STATUS_LOAD.loaded,
                error: data.STATUS_LOAD.error
            };
        });
        this.fileQueueService.findNewTask().subscribe(res => {
            this.tasks = res;
            this.tasks = this.tasks.filter((x: QueueModel) => x.target);
        });
    }

    ngOnInit(): void {
    }

    /**
     * Текстовый статус файла
     * @param item
     * Статус файла
     */
    statusLoad(item: QueueModel): string {
        const statuses = {
            new: this.loadStatuses.queued,
            job: this.loadStatuses.upload,
            ok: this.loadStatuses.loaded,
            error: this.loadStatuses.error
        };
        return statuses[item.status] ? statuses[item.status] : this.loadStatuses.error;
    }

    /**
     * "Виртуальный" процес обработки
     * @param item
     */
    loadMonitoring(item: QueueModel): string {
        switch (item.status) {
            case 'new' : {
                return '1%';
            }
            case 'job' : {
                return '90%';
            }
            case 'ok' : {
                return '100%';
            }
            case 'error' : {
                return '0%';
            }
        }
    }

    /**
     * Цвет статуса файла
     * @param item
     * Статус файла
     */
    statusLoadColor(item: QueueModel): string {
        this.minimize = false;
        const statuses = {
            new: 'queued',
            job: 'waiting',
            ok: 'success',
            error: 'error'
        };
        return statuses[item.status] ? statuses[item.status] : 'error';
    }

    hideFileQueue(status): void {
        this.minimize = status;
    }
}
